/**
 * Application route constants
 */

export const ROUTES = {
  // Auth
  LOGIN: '/',
  SELECT_ROLE: '/select-role',
  
  // Admin & Executive
  ADMIN: '/admin',
  EXECUTIVE: '/executive',
  ANALYSIS: '/analysis',
  GEOFENCES: '/admin/geofences',
  DELETION_APPROVALS: '/admin/deletion-approvals',
  SMART_WEIGHT_PILOT: '/admin/smart-weight-pilot',
  CUSTOMER_FEEDBACK: '/feedback-dashboard',
  
  // Production
  RAW_MATERIAL: '/raw-material',
  RAW_MATERIAL_WIZARD: '/raw-material-wizard',
  RAW_MATERIAL_FINAL: '/raw-material-final',
  RAW_MATERIAL_RETURN: '/raw-material-return',
  JOBWORK: '/jobwork',
  JOBWORK_WIZARD: '/jobwork-wizard',
  JOBWORK_DISPATCH: '/jobwork-dispatch',
  FURNACE: '/furnace',
  FURNACE_STOCK: '/furnace-stock',
  EXTRUSION: '/extrusion',
  ROLLING: '/rolling',
  DRAW: '/draw',
  PACKING: '/packing',
  PACKING_NEW: '/packing-new',
  VMC: '/vmc',
  PRODUCTION_DASHBOARD: '/production-dashboard',
  
  // Quality & Testing
  QUALITY: '/quality',
  
  // Dispatch
  DISPATCH: '/dispatch',
  DISPATCH_NEW: '/dispatch-new',
  DISPATCH_PRODUCTION_LOGS: '/dispatch-new/production-logs',
  DISPATCH_RETURN: '/dispatch-return',
  
  // Reports
  DAY_WORKING: '/day-working',
  
  // Consumption
  CONSUMPTION: '/consumption',
  ELECTRICITY_CONSUMPTION: '/electricity-consumption',
  
  // Orders & Planning
  ORDERS: '/orders',
  CLIENTS: '/clients',
  PLANNING: '/planning',
  PRODUCTION: '/production',
  PRODUCTION_TRACKER: '/production-tracker',
  PRODUCTION_REPORTS: '/production-reports',

  PURCHASE_ORDERS: '/purchase-orders',
  STOCK_MANAGEMENT: '/stock-management',
  BOX_PLANNER: '/box-planner',
  DIE_PLANNER: '/die-planner',
  DIE_STORE: '/die-store',
  WORK_ORDER_PLANNER: '/work-order-planner',
  PACKING_DASHBOARD: '/packing-dashboard',
  PARTY_COMPARISON: '/party-comparison',
  
  // Scrap & Rejection
  SCRAP: '/scrap',
  MELTING_SCRAP: '/melting-scrap',
  INTERNAL_REJECTION: '/internal-rejection',
  
  // Procurement
  PROCUREMENT: '/procurement',
  
  // Maintenance
  MAINTENANCE: '/maintenance',
  MAINTENANCE_PLANNER: '/maintenance-planner',
  MAINTENANCE_ANALYTICS: '/maintenance/analytics',
  TOOL_HEALTH_CHECK: '/tool-health-check',
  BREAKDOWN_REQUEST: '/breakdown-request',
  MAINTENANCE_DEPARTMENTS: '/maintenance/departments',
  MAINTENANCE_MACHINES: '/maintenance/machines',
  MAINTENANCE_TOOLS: '/maintenance/tools',
  MAINTENANCE_TASKS: '/maintenance/tasks',
  MAINTENANCE_PLANS: '/maintenance/plans',
  MAINTENANCE_BREAKDOWN_REQUESTS: '/maintenance/breakdown-requests',
  MAINTENANCE_TAXONOMY: '/maintenance/taxonomy',
  MAINTENANCE_ITEM_TRACKING: '/maintenance/item-tracking',
  MAINTENANCE_TAXONOMY_PM: '/maintenance/taxonomy-pm',
  MAINTENANCE_BRD_DASHBOARD: '/maintenance/brd-dashboard',
  MAINTENANCE_EQUIPMENT_HISTORY: '/maintenance/equipment-history',
  
  // Photos
  PHOTOS_MANAGEMENT: '/photos-management',
  OFFLINE_PHOTOS: '/offline-photos',

  // Continuous Caster
  CASTER: '/caster',

  // Furnace Raw Material FIFO
  FURNACE_MATERIAL: '/furnace-raw-material',
  FURNACE_DASHBOARD: '/furnace-dashboard',
  DAILY_FURNACE_USAGE: '/daily-furnace-usage',

  // AI (semantic search / RAG)
  AI_ASSISTANT: '/ai-assistant',

  // BRD 5 — Debit Note Reconciliation
  DEBIT_NOTE: '/debit-note-reconciliation',

  // App Gallery
  APP_GALLERY: '/app-gallery',

  // Breakdown Process Modules (separate pages end-to-end)
  BREAKDOWN_PROCESS: '/breakdown-process',
  BRD_FORM1: '/breakdown/application',
  BRD_FORM2: '/breakdown/repairable',
  BRD_FORM3: '/breakdown/costing',
  BRD_FORM4: '/breakdown/vendor-registration',
  BRD_STORE: '/breakdown/store',
  BRD_SCENARIOS: '/breakdown/scenarios',

  // Quick Breakdown Ticket — anyone on shop floor can open on phone
  QUICK_TICKET: '/quick-ticket',
};

/**
 * Route configuration with required roles
 */
export const ROUTE_CONFIG = [
  {
    path: ROUTES.ADMIN,
    roles: ['admin'],
  },
  {
    path: ROUTES.EXECUTIVE,
    roles: ['admin'],
  },
  {
    path: ROUTES.ANALYSIS,
    roles: ['admin'],
  },
  {
    path: ROUTES.GEOFENCES,
    roles: ['admin'],
  },
  {
    path: ROUTES.DELETION_APPROVALS,
    roles: ['admin'],
  },
  {
    path: ROUTES.SMART_WEIGHT_PILOT,
    roles: ['admin'],
  },
  {
    path: ROUTES.CUSTOMER_FEEDBACK,
    roles: ['admin'],
  },
  {
    path: ROUTES.CONSUMPTION,
    roles: ['admin', 'consumption', 'consumption_cost'],
  },
  {
    path: ROUTES.PROCUREMENT,
    roles: ['admin', 'procurement'],
  },
  {
    path: ROUTES.QUALITY,
    roles: ['admin', 'quality', 'test_certificate'],
  },
  {
    path: ROUTES.EXTRUSION,
    roles: ['admin', 'extrusion'],
  },
  {
    path: ROUTES.FURNACE,
    roles: ['admin', 'furnace'],
  },
  {
    path: ROUTES.FURNACE_STOCK,
    roles: ['admin', 'furnace'],
  },
  {
    path: ROUTES.ROLLING,
    roles: ['admin', 'rolling'],
  },
  {
    path: ROUTES.DRAW,
    roles: ['admin', 'draw'],
  },
  {
    path: ROUTES.DISPATCH,
    roles: ['admin', 'dispatch'],
  },
  {
    path: ROUTES.DISPATCH_NEW,
    roles: ['admin', 'dispatch'],
  },
  {
    path: ROUTES.DISPATCH_PRODUCTION_LOGS,
    roles: ['admin', 'dispatch'],
  },
  {
    path: ROUTES.DISPATCH_RETURN,
    roles: ['admin', 'dispatch'],
  },
  {
    path: ROUTES.DAY_WORKING,
    roles: ['admin', 'day_working'],
  },
  {
    path: ROUTES.VMC,
    roles: ['admin', 'vmc'],
  },
  {
    path: ROUTES.PACKING,
    roles: ['admin', 'packing'],
  },
  {
    path: ROUTES.PACKING_NEW,
    roles: ['admin', 'packing'],
  },
  {
    path: ROUTES.PACKING_DASHBOARD,
    roles: ['admin', 'packing', 'dispatch', 'order'],
  },
  {
    path: ROUTES.ELECTRICITY_CONSUMPTION,
    roles: ['admin', 'electricity_consumption'],
  },
  {
    path: ROUTES.ORDERS,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.CLIENTS,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.PLANNING,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.BOX_PLANNER,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.PRODUCTION,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.PARTY_COMPARISON,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.PURCHASE_ORDERS,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.STOCK_MANAGEMENT,
    roles: ['admin', 'dispatch', 'order'],
  },
  {
    path: ROUTES.SCRAP,
    roles: ['admin', 'scrap'],
  },
  {
    path: ROUTES.MELTING_SCRAP,
    roles: ['admin', 'scrap', 'furnace', 'raw_material'],
  },
  {
    path: ROUTES.INTERNAL_REJECTION,
    roles: ['admin', 'internal_rejection'],
  },
  {
    path: ROUTES.DIE_PLANNER,
    roles: ['admin', 'die_planner'],
  },
  {
    path: ROUTES.DIE_STORE,
    roles: ['admin', 'die_planner', 'extrusion', 'draw'],
  },
  {
    path: ROUTES.WORK_ORDER_PLANNER,
    roles: ['admin', 'order', 'purchase_order'],
  },
  {
    path: ROUTES.MAINTENANCE_PLANNER,
    roles: ['admin', 'maintenance', 'maintenance_admin', 'maintenance_mechanical', 'maintenance_electrical'],
  },
  {
    path: ROUTES.TOOL_HEALTH_CHECK,
    roles: ['admin', 'maintenance', 'maintenance_admin', 'maintenance_mechanical', 'maintenance_electrical'],
  },
  {
    path: ROUTES.BREAKDOWN_REQUEST,
    roles: [], // Available to all authenticated users
  },
  {
    path: ROUTES.MAINTENANCE,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_DEPARTMENTS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_MACHINES,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_TOOLS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_TASKS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_PLANS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_BREAKDOWN_REQUESTS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_TAXONOMY,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_ITEM_TRACKING,
    roles: ['admin', 'maintenance', 'maintenance_admin', 'maintenance_mechanical', 'maintenance_electrical'],
  },
  {
    path: ROUTES.MAINTENANCE_TAXONOMY_PM,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_BRD_DASHBOARD,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.MAINTENANCE_EQUIPMENT_HISTORY,
    roles: ['admin', 'maintenance', 'maintenance_admin', 'maintenance_mechanical', 'maintenance_electrical'],
  },
  {
    path: ROUTES.MAINTENANCE_ANALYTICS,
    roles: ['admin', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.RAW_MATERIAL,
    roles: [
      'admin',
      'raw_material',
      'furnace',
      'order',
      'purchase_order',
      'procurement',
      'jobwork',
      'store',
      'production',
      'dispatch',
    ],
  },
  {
    path: ROUTES.RAW_MATERIAL_WIZARD,
    roles: [
      'admin',
      'raw_material',
      'furnace',
      'order',
      'purchase_order',
      'procurement',
      'jobwork',
      'store',
      'production',
      'dispatch',
    ],
  },
  {
    path: ROUTES.RAW_MATERIAL_FINAL,
    roles: [
      'admin',
      'raw_material',
      'furnace',
      'order',
      'purchase_order',
      'procurement',
      'jobwork',
      'store',
      'production',
      'dispatch',
    ],
  },
  {
    path: ROUTES.RAW_MATERIAL_RETURN,
    roles: [
      'admin',
      'raw_material',
      'furnace',
      'order',
      'purchase_order',
      'procurement',
      'jobwork',
      'store',
      'production',
      'dispatch',
    ],
  },
  {
    path: ROUTES.PHOTOS_MANAGEMENT,
    roles: [
      'admin',
      'raw_material',
      'furnace',
      'order',
      'purchase_order',
      'procurement',
      'jobwork',
      'store',
      'production',
      'dispatch',
    ],
  },
  {
    path: ROUTES.JOBWORK,
    roles: ['admin', 'raw_material', 'dispatch', 'jobwork'],
  },
  {
    path: ROUTES.JOBWORK_WIZARD,
    roles: ['admin', 'raw_material', 'dispatch', 'jobwork'],
  },
  {
    path: ROUTES.JOBWORK_DISPATCH,
    roles: ['admin', 'raw_material', 'dispatch', 'jobwork'],
  },
  {
    path: ROUTES.OFFLINE_PHOTOS,
    roles: [], // Available to all authenticated users (also allowed when geofence-locked)
  },
  {
    path: ROUTES.AI_ASSISTANT,
    roles: ['admin', 'order', 'purchase_order', 'maintenance', 'maintenance_admin'],
  },
  {
    path: ROUTES.CASTER,
    roles: ['admin', 'furnace'],
  },
  {
    path: ROUTES.FURNACE_MATERIAL,
    roles: ['admin', 'furnace'],
  },
  {
    path: ROUTES.DAILY_FURNACE_USAGE,
    roles: ['admin', 'scrap', 'internal_rejection'],
  },
  {
    path: ROUTES.PRODUCTION_TRACKER,
    roles: ['admin', 'extrusion', 'furnace', 'rolling', 'draw', 'vmc', 'packing'],
  },
  {
    path: ROUTES.PRODUCTION_REPORTS,
    roles: ['admin', 'extrusion', 'rolling', 'draw', 'vmc', 'packing'],
  },
  {
    path: ROUTES.APP_GALLERY,
    roles: [], // Available to all authenticated users
  },
  {
    path: ROUTES.BREAKDOWN_PROCESS,
    roles: [], // Available to all authenticated users
  },
  {
    path: ROUTES.BRD_FORM1,
    roles: [],
  },
  {
    path: ROUTES.BRD_FORM2,
    roles: [],
  },
  {
    path: ROUTES.BRD_FORM3,
    roles: [],
  },
  {
    path: ROUTES.BRD_FORM4,
    roles: [],
  },
  {
    path: ROUTES.BRD_STORE,
    roles: [],
  },
  {
    path: ROUTES.BRD_SCENARIOS,
    roles: [],
  },
];

/**
 * Check if a route is accessible by an operator
 * @param {string} path - Route path
 * @param {Object|null} operator - Operator object
 * @returns {boolean} True if route is accessible
 */
export const isRouteAccessible = (path, operator) => {
  if (!operator) return false;
  
  const config = ROUTE_CONFIG.find((r) => r.path === path);
  if (!config) return false;
  
  if (config.roles.length === 0) return true; // Public route
  
  let roleSlugs = [];
  if (Array.isArray(operator.roles)) {
    roleSlugs = operator.roles
      .map((r) => (typeof r === 'string' ? r : r?.slug))
      .filter(Boolean);
  } else if (typeof operator.role === 'string') {
    roleSlugs = [operator.role];
  } else if (typeof operator.role_slug === 'string') {
    roleSlugs = [operator.role_slug];
  }

  if (roleSlugs.includes('admin') || operator.is_admin || operator.is_superuser) return true;
  return config.roles.some((role) => roleSlugs.includes(role));
};
